import * as React from 'react';
import { TranslationsProvider } from '@teliaee/telia-translate';
import { EnvironmentContext } from './EnvironmentContext';
import URLDataProvider from './URLDataProvider';
import JsxRenderer from './JsxRenderer';
import { LanguageContext } from './LanguageContext';
export const TRANSLATIONS_APP_NAME = 'iocc';
const TranslationsContextWrapper = (props) => {
    return (React.createElement(EnvironmentContext.Consumer, null, (environment) => (React.createElement(LanguageContext.Consumer, null, ({ lang }) => (React.createElement(URLDataProvider, null, (urlData) => (React.createElement(TranslationsProvider, { tier: environment.tier, lang: lang, translations: props.translations, labelsUrl: urlData.getTranslationsURL(), disableStatistics: props.disableStatistics, isTestEnvironment: props.isTestEnvironment, jsxRenderer: ({ jsx }) => React.createElement(JsxRenderer, { jsx: jsx }), defaultApp: TRANSLATIONS_APP_NAME }, props.children))))))));
};
export default TranslationsContextWrapper;
